import { DepreciationAmountField } from '@aloft/toolkit-shared';
import { createAction } from '@reduxjs/toolkit';

export const setDepreciation = createAction<{
  id: string;
  field: DepreciationAmountField;
  newValue: number | undefined;
}>('setDepreciation');
